import { render, staticRenderFns } from "./Hello.vue?vue&type=template&id=2a590f23&scoped=true&"
import script from "./Hello.vue?vue&type=script&lang=js&"
export * from "./Hello.vue?vue&type=script&lang=js&"
import style0 from "./Hello.vue?vue&type=style&index=0&id=2a590f23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a590f23",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/webpack/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a590f23')) {
      api.createRecord('2a590f23', component.options)
    } else {
      api.reload('2a590f23', component.options)
    }
    module.hot.accept("./Hello.vue?vue&type=template&id=2a590f23&scoped=true&", function () {
      api.rerender('2a590f23', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public_html/packages/ae_theme/themes/ae/assets/js/modules/vue-components/Hello.vue"
export default component.exports